import {
  auctionState,
  getHomeOngoingAuctionsUrl,
  getProductDetailUrl,
  joinAuctionUrl,
  joinedAuctionsUrl,
  pastAuctionurl,
  publicgetHomeOngoingAuctionsUrl,
} from "../common/config/app.endpoints";
import { oAuth } from "../routes/basic/BasicAppRouter";
import api, { publicApi } from "./ApiService";

const auctions = async (): Promise<any> => {
  try {
    const isAuth = oAuth();
    console.log("Is Authenticated:", isAuth);
    const url = isAuth
      ? getHomeOngoingAuctionsUrl
      : publicgetHomeOngoingAuctionsUrl;
    const client = isAuth ? api : publicApi;

    const response = await client.get(url);
    console.log("Full API response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching auction list:", error);
    throw error;
  }
};
export const AuctionInvite = async (auctionId: any) => {
  try {
    const response = await api.post(
      `${joinAuctionUrl}/${auctionId}/joinAuction`
    );
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);
    return null;
  }
};
export const joinAuction = async () => {
  try {
    const response = await api.get(`${joinedAuctionsUrl}`);
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);
    return null;
  }
};
export const AuctionState = async (auctionId: any) => {
  try {
    const response = await api.get(`${auctionState}/${auctionId}/state`);
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);
    return null;
  }
};
export const ProductState = async (productId: any) => {
  try {
    const response = await api.get(
      `${getProductDetailUrl}/${productId}/stateNAuctionState`
    );
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);
    return null;
  }
};
const reqbody = {
  filters: { or: [], and: [] },
  page: {
    start: 0,
    count: 20,
    sort: { orders: [{ property: "serialNo", direction: "ASC" }] },
  },
};
export const getPastProducts = async (): Promise<any> => {
  try {
    const response = await publicApi.post(pastAuctionurl, reqbody);
    console.log("Full API response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching auction list:", error);
    throw error;
  }
};

export default auctions;
